import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-3681e74d"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { key: 0 };
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { getTransportOriginMarkerIcon, getTransportDestinationMarkerIcon, getTransportExclusionMarkerIcon, getTransportMarkerLabel, getTransportMarkerId, } from '../../../generic/map/mapMarkerConfig';
import TransportMarkerInfoWindow from '../infoWindows/TransportMarkerInfoWindow.vue';
import TransportMapMarkerTooltip from '../tooltip/TransportMapMarkerTooltip.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AssignmentMapTransportMarker',
    props: {
        transport: {
            type: Object,
            required: true,
        },
        isOrigin: {
            type: Boolean,
            required: true,
        },
        activeInfoWindowId: {
            type: String,
            default: null,
        },
        toggleInfoWindow: {
            type: Function,
            default: function () { },
        },
    },
    setup: function (__props) {
        var props = __props;
        var t = useI18n({ useScope: 'global' }).t;
        var getMarkerIcon = function () {
            return props.isOrigin ?
                getTransportOriginMarkerIcon(props.transport) :
                getTransportDestinationMarkerIcon(props.transport);
        };
        var markerId = computed(function () { return getTransportMarkerId(props.transport, props.isOrigin); });
        var showInfoWindow = computed(function () { return markerId.value === props.activeInfoWindowId; });
        var markerCoordinates = computed(function () {
            return props.isOrigin ?
                props.transport.coordinates :
                props.transport.destinationCoordinates;
        });
        var showToolTip = ref(false);
        var onMouseOver = function () {
            showToolTip.value = true;
        };
        var onMouseOut = function () {
            showToolTip.value = false;
        };
        return function (_ctx, _cache) {
            var _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow");
            var _component_GMapMarker = _resolveComponent("GMapMarker");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_GMapMarker, {
                    position: markerCoordinates.value,
                    icon: getMarkerIcon(),
                    label: _unref(getTransportMarkerLabel)(__props.transport),
                    clickable: true,
                    draggable: false,
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (__props.toggleInfoWindow(markerId.value)); }),
                    onMouseover: onMouseOver,
                    onMouseout: onMouseOut
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_GMapInfoWindow, {
                            opened: showInfoWindow.value,
                            class: "info-window",
                            position: markerCoordinates.value
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(TransportMarkerInfoWindow, { transport: __props.transport }, null, 8 /* PROPS */, ["transport"])
                            ]; }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["opened", "position"]),
                        _createVNode(TransportMapMarkerTooltip, {
                            transport: __props.transport,
                            isVisible: showToolTip.value && !showInfoWindow.value
                        }, null, 8 /* PROPS */, ["transport", "isVisible"])
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["position", "icon", "label"]),
                (__props.transport.isExcludedFromAssistedAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_GMapMarker, {
                            position: markerCoordinates.value,
                            icon: _unref(getTransportExclusionMarkerIcon)(__props.isOrigin).background,
                            clickable: false,
                            draggable: false
                        }, null, 8 /* PROPS */, ["position", "icon"]),
                        _createVNode(_component_GMapMarker, {
                            position: markerCoordinates.value,
                            icon: _unref(getTransportExclusionMarkerIcon)(__props.isOrigin).foreground,
                            clickable: false,
                            draggable: false
                        }, null, 8 /* PROPS */, ["position", "icon"])
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
